import React from 'react';
const ScrollElementContext = React.createContext(null);

export default ScrollElementContext;
